/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { REGIONS } from "../../../constants";

export const GET_FILES_RESPONSE = {
	files: [
		{
			name: "file1.xlsx",
			id: "1"
		},
		{
			name: "file2.xlsx",
			id: "2"
		},
		{
			name: "file3.xlsx",
			id: "3"
		}
	]
};

export const GET_CATEGORIES_RESPONSE = {
	categories: [
		"Server",
		"Network",
		"Storage",
		"Firewall",
		"Network Equipment Chassis",
		"Payment Terminal"
	]
};

export const GET_GENERAL_INFORMATION_RESPONSE = {
	totalEmission: {
		label: "Total Emission",
		value: 9.88,
		unit: "kgCo2e"
	},
	scope2Emission: {
		label: "Scope 2 Emission",
		value: 6.12,
		unit: "kgCo2e"
	},
	scope3Emission: {
		label: "Scope 3 Emission",
		value: 3.76,
		unit: "kgCo2e"
	},
	totalAssetsCount: {
		label: "Total assets count",
		value: 2147
	},
	manufacterCount: {
		label: "Manufacturer count",
		value: 35
	}
};

export const GET_TOTAL_EMISSION_FOR_PIE_CHART_RESPONSE = {
	title: "Resources Emissions",
	PieChartSlice: [
		{
			name: "DELL Computer Corp",
			value: 6748609.28,
			unit: "kgCo2e"
		},
		{
			name: "Hewlett Packard Enterprise Company",
			value: 854255.57,
			unit: "kgCo2e"
		},
		{
			name: "CISCO Systems Inc",
			value: 691158.12,
			unit: "kgCo2e"
		},
		{
			name: "ARISTA",
			value: 93721.65,
			unit: "kgCo2e"
		},
		{
			name: "IBM Corporation",
			value: 92920.69,
			unit: "kgCo2e"
		},
		{
			name: "LENOVO",
			value: 91570.89,
			unit: "kgCo2e"
		},
		{
			name: "Checkpoint Systems Inc",
			value: 67009.35,
			unit: "kgCo2e"
		},
		{
			name: "Hitachi Data Systems",
			value: 45023.15,
			unit: "kgCo2e"
		},
		{
			name: "Palo Alto Networks",
			value: 37087.98,
			unit: "kgCo2e"
		},
		{
			name: "Microsemi Corporation",
			value: 20400.29,
			unit: "kgCo2e"
		},
		{
			name: "Other 17 Manufacturers",
			value: 20200.14,
			unit: "kgCo2e"
		}
	]
};

export const GET_EMISSIONS_BY_MODEL_RESPONSE = {
	title: "Highest environmental impact - Models",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{
					name: "Dell Inc. Latitude 5420",
					value: 5051273,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5440",
					value: 2721962,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5430",
					value: 2267962,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5450",
					value: 1950808,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5410",
					value: 1533000,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5420",
					value: 1323808,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5540",
					value: 1157808,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5550",
					value: 1054000,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5400",
					value: 990892,
					unit: "kgCO2"
				},
				{
					name: "Dell Inc. Latitude 5490",
					value: 794892,
					unit: "kgCO2"
				}
			]
		}
	]
};

export const GET_EMISSIONS_BY_MODEL_PER_DEVICE_RESPONSE = {
	title: "Highest environmental impact - Models (per device)",
	barSeries: [
		{
			name: "Average CO2",
			bars: [
				{
					name: "Dell Inspiron 20",
					value: 38.6,
					unit: "kgCO2"
				},
				{
					name: "Apple Macbook Air 2015",
					value: 32.1,
					unit: "kgCO2"
				},
				{
					name: "Apple Macbook Pro 2018",
					value: 28.4,
					unit: "kgCO2"
				},
				{
					name: "Acer Predator Helios",
					value: 25.3,
					unit: "kgCO2"
				},
				{
					name: "Apple Macbook Pro 2020",
					value: 19.9,
					unit: "kgCO2"
				},
				{
					name: "Dell XPS 15",
					value: 17.2,
					unit: "kgCO2"
				},
				{
					name: "Asus Vivobook 17",
					value: 15.4,
					unit: "kgCO2"
				},
				{
					name: "Apple Macbook Pro 2022",
					value: 12.7,
					unit: "kgCO2"
				},
				{
					name: "Samsung Galaxy Book 14",
					value: 9.1,
					unit: "kgCO2"
				},
				{
					name: "Apple Macbook Pro 2025",
					value: 6.3,
					unit: "kgCO2"
				}
			]
		}
	]
};

export const GET_EMISSIONS_BY_REGION_RESPONSE = {
	title: "Highest environmental impact - Regions",
	barSeries: [
		{
			name: "Environmental Impact",
			bars: [
				{
					name: "ES",
					value: 8737000,
					unit: "kgCO2"
				},
				{
					name: "PE",
					value: 2601000,
					unit: "kgCO2"
				},
				{
					name: "IT",
					value: 2601000,
					unit: "kgCO2"
				},
				{
					name: "BR",
					value: 2417000,
					unit: "kgCO2"
				},
				{
					name: "DE",
					value: 1155000,
					unit: "kgCO2"
				},
				{
					name: "ES",
					value: 1116000,
					unit: "kgCO2"
				},
				{
					name: "GB",
					value: 1042000,
					unit: "kgCO2"
				},
				{
					name: "MX",
					value: 937000,
					unit: "kgCO2"
				},
				{
					name: "CL",
					value: 950000,
					unit: "kgCO2"
				},
				{
					name: "CO",
					value: 826400,
					unit: "kgCO2"
				},
				{
					name: "RO",
					value: 704000,
					unit: "kgCO2"
				}
			]
		}
	]
};

export const GET_EMISSIONS_BY_REGION_PER_DEVICE_RESPONSE = {
	title: "Highest environmental impact - Regions (per device)",
	barSeries: [
		{
			name: "Average CO2",
			bars: [
				{ name: "ES", value: 42.1, unit: "kgCO2" },
				{ name: "PE", value: 39.5, unit: "kgCO2" },
				{ name: "IT", value: 37.3, unit: "kgCO2" },
				{ name: "BR", value: 35.7, unit: "kgCO2" },
				{ name: "DE", value: 31.2, unit: "kgCO2" },
				{ name: "GB", value: 27.8, unit: "kgCO2" },
				{ name: "MX", value: 24.4, unit: "kgCO2" },
				{ name: "CL", value: 21.1, unit: "kgCO2" },
				{ name: "CO", value: 18.6, unit: "kgCO2" },
				{ name: "RO", value: 15.2, unit: "kgCO2" }
			]
		}
	]
};

export const GET_CO2_BY_INSTALL_STATUS_DISTRIBUTION = {
	title: "Resources Emissions",
	PieChartSlice: [
		{
			name: "In use",
			value: 6748609.28,
			unit: "kgCo2e"
		},
		{
			name: "In transit",
			value: 854255.57,
			unit: "kgCo2e"
		},
		{
			name: "In stock",
			value: 691158.12,
			unit: "kgCo2e"
		},
		{
			name: "In maintenance",
			value: 93721.65,
			unit: "kgCo2e"
		}
	]
};

export const GET_EMISSIONS_OVER_TIME_RESPONSE = {
	title: "Total Emissions Over Time (data from 6 assets - 66.67% of total)",
	lineSeries: [
		{
			name: "Scope2 Emissions",
			linePoints: [
				{
					name: "2017-11",
					value: 1.68,
					unit: "kgCO2e"
				},
				{
					name: "2017-12",
					value: 1.68,
					unit: "kgCO2e"
				},
				{
					name: "2018-01",
					value: 1.68,
					unit: "kgCO2e"
				},
				{
					name: "2018-02",
					value: 1.68,
					unit: "kgCO2e"
				},
				{
					name: "2018-03",
					value: 1.68,
					unit: "kgCO2e"
				},
				{
					name: "2018-04",
					value: 1.68,
					unit: "kgCO2e"
				},
				{
					name: "2018-05",
					value: 1.68,
					unit: "kgCO2e"
				},
				{
					name: "2018-06",
					value: 1.68,
					unit: "kgCO2e"
				},
				{
					name: "2018-07",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2018-08",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2018-09",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2018-10",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2018-11",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2018-12",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-01",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-02",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-03",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-04",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-05",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-06",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-07",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-08",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-09",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-10",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-11",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2019-12",
					value: 1.86,
					unit: "kgCO2e"
				},
				{
					name: "2020-01",
					value: 2.06,
					unit: "kgCO2e"
				},
				{
					name: "2020-02",
					value: 2.06,
					unit: "kgCO2e"
				},
				{
					name: "2020-03",
					value: 2.06,
					unit: "kgCO2e"
				},
				{
					name: "2020-04",
					value: 2.06,
					unit: "kgCO2e"
				},
				{
					name: "2020-05",
					value: 2.06,
					unit: "kgCO2e"
				},
				{
					name: "2020-06",
					value: 2.06,
					unit: "kgCO2e"
				},
				{
					name: "2020-07",
					value: 2.06,
					unit: "kgCO2e"
				},
				{
					name: "2020-08",
					value: 2.47,
					unit: "kgCO2e"
				},
				{
					name: "2020-09",
					value: 2.47,
					unit: "kgCO2e"
				},
				{
					name: "2020-10",
					value: 2.47,
					unit: "kgCO2e"
				},
				{
					name: "2020-11",
					value: 2.47,
					unit: "kgCO2e"
				},
				{
					name: "2020-12",
					value: 2.47,
					unit: "kgCO2e"
				},
				{
					name: "2021-01",
					value: 2.47,
					unit: "kgCO2e"
				},
				{
					name: "2021-02",
					value: 2.47,
					unit: "kgCO2e"
				},
				{
					name: "2021-03",
					value: 3.0,
					unit: "kgCO2e"
				},
				{
					name: "2021-04",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2021-05",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2021-06",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2021-07",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2021-08",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2021-09",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2021-10",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2021-11",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2021-12",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-01",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-02",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-03",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-04",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-05",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-06",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-07",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-08",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-09",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-10",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-11",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2022-12",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-01",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-02",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-03",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-04",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-05",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-06",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-07",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-08",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-09",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-10",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-11",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2023-12",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-01",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-02",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-03",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-04",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-05",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-06",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-07",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-08",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-09",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-10",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-11",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2024-12",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-01",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-02",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-03",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-04",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-05",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-06",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-07",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-08",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-09",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-10",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-11",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2025-12",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2026-01",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2026-02",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2026-03",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2026-04",
					value: 3.16,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Scope3 Emissions",
			linePoints: [
				{
					name: "2017-11",
					value: 0.16,
					unit: "kgCO2e"
				},
				{
					name: "2017-12",
					value: 0.16,
					unit: "kgCO2e"
				},
				{
					name: "2018-01",
					value: 0.16,
					unit: "kgCO2e"
				},
				{
					name: "2018-02",
					value: 0.16,
					unit: "kgCO2e"
				},
				{
					name: "2018-03",
					value: 0.16,
					unit: "kgCO2e"
				},
				{
					name: "2018-04",
					value: 0.16,
					unit: "kgCO2e"
				},
				{
					name: "2018-05",
					value: 0.16,
					unit: "kgCO2e"
				},
				{
					name: "2018-06",
					value: 0.16,
					unit: "kgCO2e"
				},
				{
					name: "2018-07",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2018-08",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2018-09",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2018-10",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2018-11",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2018-12",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-01",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-02",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-03",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-04",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-05",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-06",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-07",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-08",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-09",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-10",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-11",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2019-12",
					value: 3.45,
					unit: "kgCO2e"
				},
				{
					name: "2020-01",
					value: 7.5,
					unit: "kgCO2e"
				},
				{
					name: "2020-02",
					value: 7.5,
					unit: "kgCO2e"
				},
				{
					name: "2020-03",
					value: 7.5,
					unit: "kgCO2e"
				},
				{
					name: "2020-04",
					value: 7.5,
					unit: "kgCO2e"
				},
				{
					name: "2020-05",
					value: 7.5,
					unit: "kgCO2e"
				},
				{
					name: "2020-06",
					value: 7.5,
					unit: "kgCO2e"
				},
				{
					name: "2020-07",
					value: 7.5,
					unit: "kgCO2e"
				},
				{
					name: "2020-08",
					value: 12.0,
					unit: "kgCO2e"
				},
				{
					name: "2020-09",
					value: 12.0,
					unit: "kgCO2e"
				},
				{
					name: "2020-10",
					value: 12.0,
					unit: "kgCO2e"
				},
				{
					name: "2020-11",
					value: 12.0,
					unit: "kgCO2e"
				},
				{
					name: "2020-12",
					value: 12.0,
					unit: "kgCO2e"
				},
				{
					name: "2021-01",
					value: 12.0,
					unit: "kgCO2e"
				},
				{
					name: "2021-02",
					value: 12.0,
					unit: "kgCO2e"
				},
				{
					name: "2021-03",
					value: 17.04,
					unit: "kgCO2e"
				},
				{
					name: "2021-04",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2021-05",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2021-06",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2021-07",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2021-08",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2021-09",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2021-10",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2021-11",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2021-12",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-01",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-02",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-03",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-04",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-05",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-06",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-07",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-08",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-09",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-10",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-11",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2022-12",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-01",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-02",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-03",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-04",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-05",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-06",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-07",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-08",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-09",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-10",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-11",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2023-12",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-01",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-02",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-03",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-04",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-05",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-06",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-07",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-08",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-09",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-10",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-11",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2024-12",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-01",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-02",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-03",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-04",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-05",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-06",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-07",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-08",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-09",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-10",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-11",
					value: 17.32,
					unit: "kgCO2e"
				},
				{
					name: "2025-12",
					value: 14.04,
					unit: "kgCO2e"
				},
				{
					name: "2026-01",
					value: 0.0,
					unit: "kgCO2e"
				},
				{
					name: "2026-02",
					value: 0.0,
					unit: "kgCO2e"
				},
				{
					name: "2026-03",
					value: 0.0,
					unit: "kgCO2e"
				},
				{
					name: "2026-04",
					value: 0.0,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Total Emissions",
			linePoints: [
				{
					name: "2017-11",
					value: 1.84,
					unit: "kgCO2e"
				},
				{
					name: "2017-12",
					value: 1.84,
					unit: "kgCO2e"
				},
				{
					name: "2018-01",
					value: 1.84,
					unit: "kgCO2e"
				},
				{
					name: "2018-02",
					value: 1.84,
					unit: "kgCO2e"
				},
				{
					name: "2018-03",
					value: 1.84,
					unit: "kgCO2e"
				},
				{
					name: "2018-04",
					value: 1.84,
					unit: "kgCO2e"
				},
				{
					name: "2018-05",
					value: 1.84,
					unit: "kgCO2e"
				},
				{
					name: "2018-06",
					value: 1.84,
					unit: "kgCO2e"
				},
				{
					name: "2018-07",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2018-08",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2018-09",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2018-10",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2018-11",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2018-12",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-01",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-02",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-03",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-04",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-05",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-06",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-07",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-08",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-09",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-10",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-11",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2019-12",
					value: 5.3,
					unit: "kgCO2e"
				},
				{
					name: "2020-01",
					value: 9.56,
					unit: "kgCO2e"
				},
				{
					name: "2020-02",
					value: 9.56,
					unit: "kgCO2e"
				},
				{
					name: "2020-03",
					value: 9.56,
					unit: "kgCO2e"
				},
				{
					name: "2020-04",
					value: 9.56,
					unit: "kgCO2e"
				},
				{
					name: "2020-05",
					value: 9.56,
					unit: "kgCO2e"
				},
				{
					name: "2020-06",
					value: 9.56,
					unit: "kgCO2e"
				},
				{
					name: "2020-07",
					value: 9.56,
					unit: "kgCO2e"
				},
				{
					name: "2020-08",
					value: 14.47,
					unit: "kgCO2e"
				},
				{
					name: "2020-09",
					value: 14.47,
					unit: "kgCO2e"
				},
				{
					name: "2020-10",
					value: 14.47,
					unit: "kgCO2e"
				},
				{
					name: "2020-11",
					value: 14.47,
					unit: "kgCO2e"
				},
				{
					name: "2020-12",
					value: 14.47,
					unit: "kgCO2e"
				},
				{
					name: "2021-01",
					value: 14.47,
					unit: "kgCO2e"
				},
				{
					name: "2021-02",
					value: 14.47,
					unit: "kgCO2e"
				},
				{
					name: "2021-03",
					value: 20.04,
					unit: "kgCO2e"
				},
				{
					name: "2021-04",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2021-05",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2021-06",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2021-07",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2021-08",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2021-09",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2021-10",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2021-11",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2021-12",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-01",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-02",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-03",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-04",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-05",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-06",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-07",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-08",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-09",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-10",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-11",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2022-12",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-01",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-02",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-03",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-04",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-05",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-06",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-07",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-08",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-09",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-10",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-11",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2023-12",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-01",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-02",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-03",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-04",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-05",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-06",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-07",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-08",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-09",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-10",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-11",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2024-12",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-01",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-02",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-03",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-04",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-05",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-06",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-07",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-08",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-09",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-10",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-11",
					value: 20.48,
					unit: "kgCO2e"
				},
				{
					name: "2025-12",
					value: 17.2,
					unit: "kgCO2e"
				},
				{
					name: "2026-01",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2026-02",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2026-03",
					value: 3.16,
					unit: "kgCO2e"
				},
				{
					name: "2026-04",
					value: 3.16,
					unit: "kgCO2e"
				}
			]
		}
	]
}; /* {
	title: "Total Emissions Over Time",
	lineSeries: [
		{
			name: "Total Emissions",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 70000, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 140000, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 210000, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 280000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 300000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 310000, unit: "kgCO2e" }
			]
		},
		{
			name: "Scope 2",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 60000, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 120000, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 180000, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 240000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 250000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 260000, unit: "kgCO2e" }
			]
		},
		{
			name: "Scope 3",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 10000, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 20000, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 30000, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 40000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 50000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 50000, unit: "kgCO2e" }
			]
		}
	]
}; */

export const GET_EMISSIONS_BY_COUNTRY_OVER_TIME_RESPONSE = {
	title: "Total Emissions Over Time by Country",
	lineSeries: [
		{
			name: "ES",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 70000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 140000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 230000, unit: "kgCO2e" }
			]
		},
		{
			name: "PE",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 30000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 60000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 100000, unit: "kgCO2e" }
			]
		},
		{
			name: "IT",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 28000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 56000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 97000, unit: "kgCO2e" }
			]
		},
		{
			name: "BR",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 15000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 30000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 60000, unit: "kgCO2e" }
			]
		},
		{
			name: "DE",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 10000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 20000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 40000, unit: "kgCO2e" }
			]
		}
	]
};

export const GET_SAVED_LIFECYCLE_EMISSIONS_RESPONSE = {
	title: "Saved Lifecycle Emissions",
	lineSeries: [
		{
			name: "Total Emissions",
			linePoints: [
				{ name: "2019-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-02-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-03-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-04-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-05-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-06-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-07-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-08-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-09-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-10-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-11-01", value: 0, unit: "kgCO2e" },
				{ name: "2019-12-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-02-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-03-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-04-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-05-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-06-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-07-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-08-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-09-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-10-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-11-01", value: 0, unit: "kgCO2e" },
				{ name: "2020-12-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-02-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-03-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-04-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-05-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-06-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-07-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-08-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-09-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-10-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-11-01", value: 0, unit: "kgCO2e" },
				{ name: "2021-12-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-01-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-02-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-03-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-04-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-05-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-06-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-07-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-08-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-09-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-10-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-11-01", value: 0, unit: "kgCO2e" },
				{ name: "2022-12-01", value: 0, unit: "kgCO2e" },
				{ name: "2023-01-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-02-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-03-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-04-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-05-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-06-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-07-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-08-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-09-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-10-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-11-01", value: 70000, unit: "kgCO2e" },
				{ name: "2023-12-01", value: 70000, unit: "kgCO2e" },
				{ name: "2024-01-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-02-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-03-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-04-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-05-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-06-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-07-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-08-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-09-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-10-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-11-01", value: 140000, unit: "kgCO2e" },
				{ name: "2024-12-01", value: 140000, unit: "kgCO2e" },
				{ name: "2025-01-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-02-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-03-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-04-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-05-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-06-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-07-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-08-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-09-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-10-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-11-01", value: 230000, unit: "kgCO2e" },
				{ name: "2025-12-01", value: 230000, unit: "kgCO2e" }
			]
		}
	]
};

export const GET_MANUFACTURERS_EMISSION_RESPONSE = {
	manufacturersEmissions: [
		{
			manufacturer: "DELL Computer Corp",
			parts: 646,
			emissionValue: 6748609.28,
			total: 876957.11
		},
		{
			manufacturer: "Hewlett Packard Enterprise Company",
			parts: 234,
			emissionValue: 854255.57,
			total: 876957.11
		},
		{
			manufacturer: "CISCO Systems Inc",
			parts: 290,
			emissionValue: 691158.12,
			total: 876957.11
		},
		{
			manufacturer: "ARISTA",
			parts: 230,
			emissionValue: 93721.65,
			total: 876957.11
		},
		{
			manufacturer: "IBM Corporation",
			parts: 27,
			emissionValue: 92920.69,
			total: 876957.11
		},
		{
			manufacturer: "LENOVO",
			parts: 18,
			emissionValue: 91570.89,
			total: 876957.11
		},
		{
			manufacturer: "Checkpoint Systems Inc",
			parts: 21,
			emissionValue: 67009.35,
			total: 876957.11
		},
		{
			manufacturer: "Hitachi Data Systems",
			parts: 8,
			emissionValue: 45023.15,
			total: 876957.11
		},
		{
			manufacturer: "Palo Alto Networks",
			parts: 91,
			emissionValue: 37087.98,
			total: 876957.11
		},
		{
			manufacturer: "Microsemi Corporation",
			parts: 100,
			emissionValue: 20400.29,
			total: 876957.11
		}
	]
};
export const GET_CARBON_FOOTPRINT_RESPONSE = {
	barSeries: [
		{
			name: "Upstream Scope3 Emission",
			bars: [
				{
					name: "Server",
					value: 61,
					unit: "kgCO2e"
				},
				{
					name: "Network",
					value: 10,
					unit: "kgCO2e"
				},
				{
					name: "Storage",
					value: 2,
					unit: "kgCO2e"
				},
				{
					name: "Firewall",
					value: 3,
					unit: "kgCO2e"
				},
				{
					name: "Network Equipment Chassis",
					value: 20,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal",
					value: 50,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 2",
					value: 43,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 3",
					value: 60,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 4",
					value: 38,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Scope 2 Emission",
			bars: [
				{
					name: "Server",
					value: 20,
					unit: "kgCO2e"
				},
				{
					name: "Network",
					value: 21,
					unit: "kgCO2e"
				},
				{
					name: "Storage",
					value: 10,
					unit: "kgCO2e"
				},
				{
					name: "Firewall",
					value: 18,
					unit: "kgCO2e"
				},
				{
					name: "Network Equipment Chassis",
					value: 19,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal",
					value: 33,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 2",
					value: 50,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 3",
					value: 29,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 4",
					value: 16,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Downstream Scope3 Emission",
			bars: [
				{
					name: "Server",
					value: 10,
					unit: "kgCO2e"
				},
				{
					name: "Network",
					value: 22,
					unit: "kgCO2e"
				},
				{
					name: "Storage",
					value: 50,
					unit: "kgCO2e"
				},
				{
					name: "Firewall",
					value: 30,
					unit: "kgCO2e"
				},
				{
					name: "Network Equipment Chassis",
					value: 20,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal",
					value: 17,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 2",
					value: 50,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 3",
					value: 61,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 4",
					value: 35,
					unit: "kgCO2e"
				}
			]
		}
	]
};

export const GET_CARBON_FOOTPRINT_BY_SCOPE_VALUE_RESPONSE = {
	barSeries: [
		{
			name: "Upstream Scope3 Emission",
			bars: [
				{
					name: "ARISTA",
					value: 11,
					unit: "kgCO2e"
				},
				{
					name: "Checkpoint Systems Inc",
					value: 10,
					unit: "kgCO2e"
				},
				{
					name: "Hitachi Data Systems",
					value: 2,
					unit: "kgCO2e"
				},
				{
					name: "Hitachi Data Systems Corp",
					value: 3,
					unit: "kgCO2e"
				},
				{
					name: "Hewlett Packard Enterprise Company",
					value: 20,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Scope 2 Emission",
			bars: [
				{
					name: "ARISTA",
					value: 20,
					unit: "kgCO2e"
				},
				{
					name: "Checkpoint Systems Inc",
					value: 21,
					unit: "kgCO2e"
				},
				{
					name: "Hitachi Data Systems",
					value: 10,
					unit: "kgCO2e"
				},
				{
					name: "Hitachi Data Systems Corp",
					value: 18,
					unit: "kgCO2e"
				},
				{
					name: "Hewlett Packard Enterprise Company",
					value: 19,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Downstream Scope3 Emission",
			bars: [
				{
					name: "ARISTA",
					value: 10,
					unit: "kgCO2e"
				},
				{
					name: "Checkpoint Systems Inc",
					value: 22,
					unit: "kgCO2e"
				},
				{
					name: "Hitachi Data Systems",
					value: 50,
					unit: "kgCO2e"
				},
				{
					name: "Hitachi Data Systems Corp",
					value: 30,
					unit: "kgCO2e"
				},
				{
					name: "Hewlett Packard Enterprise Company",
					value: 20,
					unit: "kgCO2e"
				}
			]
		}
	]
};

export const GET_CARBON_FOOTPRINT_BY_SCOPE_PERCENTAGE_RESPONSE = {
	barSeries: [
		{
			name: "Upstream Scope3 Emission",
			bars: [
				{
					name: "ARISTA",
					value: 10,
					unit: "%"
				},
				{
					name: "Checkpoint Systems Inc",
					value: 30,
					unit: "%"
				},
				{
					name: "Hitachi Data Systems",
					value: 5,
					unit: "%"
				},
				{
					name: "Hitachi Data Systems Corp",
					value: 30,
					unit: "%"
				},
				{
					name: "Hewlett Packard Enterprise Company",
					value: 20,
					unit: "%"
				}
			]
		},
		{
			name: "Scope 2 Emission",
			bars: [
				{
					name: "ARISTA",
					value: 20,
					unit: "%"
				},
				{
					name: "Checkpoint Systems Inc",
					value: 46,
					unit: "%"
				},
				{
					name: "Hitachi Data Systems",
					value: 10,
					unit: "%"
				},
				{
					name: "Hitachi Data Systems Corp",
					value: 18,
					unit: "%"
				},
				{
					name: "Hewlett Packard Enterprise Company",
					value: 19,
					unit: "%"
				}
			]
		},
		{
			name: "Downstream Scope3 Emission",
			bars: [
				{
					name: "ARISTA",
					value: 10,
					unit: "%"
				},
				{
					name: "Checkpoint Systems Inc",
					value: 22,
					unit: "%"
				},
				{
					name: "Hitachi Data Systems",
					value: 50,
					unit: "%"
				},
				{
					name: "Hitachi Data Systems Corp",
					value: 30,
					unit: "%"
				},
				{
					name: "Hewlett Packard Enterprise Company",
					value: 20,
					unit: "%"
				}
			]
		}
	]
};

export const GET_MANUFACTURERS_RESPONSE = {
	manufacturers: [
		"DELL Computer Corp",
		"Hewlett Packard Enterprise Company",
		"CISCO Systems Inc",
		"ARISTA",
		"IBM Corporation",
		"LENOVO",
		"Checkpoint Systems Inc",
		"Hitachi Data Systems",
		"Palo Alto Networks",
		"Microsemi Corporation"
	]
};

export const GET_ALL_COUNTRIES_RESPONSE = {
	locations: REGIONS
};

export const GET_ALL_MANUFACTURERS_RESPONSE = {
	manufacturers: [
		"DELL Computer Corp",
		"Hewlett Packard Enterprise Company",
		"CISCO Systems Inc",
		"ARISTA",
		"IBM Corporation",
		"LENOVO",
		"Checkpoint Systems Inc",
		"Hitachi Data Systems",
		"Palo Alto Networks",
		"Microsemi Corporation"
	]
};

export const GET_COMPUTE_RESPONSE = {
	calculationId: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
};

export const GET_GENERAL_CATEGORIES_RESPONSE = {
	categories: [
		"Server",
		"Network",
		"Storage",
		"Firewall",
		"Network Equipment Chassis",
		"Payment Terminal"
	]
};

export const GET_SPECIFIC_CATEGORIES_RESPONSE = {
	categories: ["Server", "Network"]
};

export const GET_TOTAL_EMISSION_RESPONSE = {
	title: "Total emission by category",
	barSeries: [
		{
			bars: [
				{
					name: "Server",
					value: 1200,
					unit: "kgCO2e"
				},
				{
					name: "Network",
					value: 850,
					unit: "kgCO2e"
				},
				{
					name: "Storage",
					value: 430,
					unit: "kgCO2e"
				},
				{
					name: "Firewall",
					value: 210,
					unit: "kgCO2e"
				},
				{
					name: "Network Equipment Chassis",
					value: 320,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal",
					value: 150,
					unit: "kgCO2e"
				}
			]
		}
	]
};

export const GET_EMISSION_OVERVIEW_RESPONSE = {
	devices: [
		{
			manufacturer: "Apple",
			scope2Co2e: 145.2,
			scope3Co2e: 145.2,
			totalCo2e: 290.4,
			manufacturerPartNumber: "MacbookPro",
			partsCount: 10
		},
		{
			manufacturer: "DELL Computer Corp",
			scope2Co2e: 200.5,
			scope3Co2e: 180.3,
			totalCo2e: 380.8,
			manufacturerPartNumber: "Latitude5490",
			partsCount: 25
		},
		{
			manufacturer: "Hewlett Packard Enterprise Company",
			scope2Co2e: 120.0,
			scope3Co2e: 160.0,
			totalCo2e: 280.0,
			manufacturerPartNumber: "ProLiantDL380",
			partsCount: 15
		},
		{
			manufacturer: "CISCO Systems Inc",
			scope2Co2e: 90.7,
			scope3Co2e: 110.2,
			totalCo2e: 200.9,
			manufacturerPartNumber: "Catalyst9300",
			partsCount: 8
		},
		{
			manufacturer: "LENOVO",
			scope2Co2e: 75.0,
			scope3Co2e: 95.0,
			totalCo2e: 170.0,
			manufacturerPartNumber: "ThinkPadX1",
			partsCount: 12
		}
	]
};

export const GET_CALCULATION_KPIS_RESPONSE = {
	totalCo2: 131.22,
	totalEnergy: 0.27,
	equivalentTrees: 0.15,
	equivalentAuto: 0.15,
	equivalentFlight: 0.24
};

export const GET_EMISSION_BY_SCOPE_RESPONSE = {
	title: "Emission by scope",
	PieChartSlice: [
		{
			name: "Scope 3",
			value: 440,
			unit: "kgCO2e"
		},
		{
			label: "Scope 2",
			value: 120,
			unit: "kgCO2e"
		}
	]
};

export const GET_EMISSION_BY_MANUFACTURER_RESPONSE = {
	title: "Emission by manufacturer",
	PieChartSlice: [
		{
			name: "DELL Computer Corp",
			value: 320,
			unit: "kgCO2e"
		},
		{
			name: "Hewlett Packard Enterprise Company",
			value: 210,
			unit: "kgCO2e"
		},
		{
			name: "CISCO Systems Inc",
			value: 180,
			unit: "kgCO2e"
		},
		{
			name: "ARISTA",
			value: 90,
			unit: "kgCO2e"
		},
		{
			name: "IBM Corporation",
			value: 60,
			unit: "kgCO2e"
		},
		{
			name: "LENOVO",
			value: 55,
			unit: "kgCO2e"
		},
		{
			name: "Checkpoint Systems Inc",
			value: 40,
			unit: "kgCO2e"
		},
		{
			name: "Hitachi Data Systems",
			value: 30,
			unit: "kgCO2e"
		},
		{
			name: "Palo Alto Networks",
			value: 25,
			unit: "kgCO2e"
		},
		{
			name: "Microsemi Corporation",
			value: 20,
			unit: "kgCO2e"
		},
		{
			name: "Other Manufacturers",
			value: 15,
			unit: "kgCO2e"
		}
	]
};

export const GET_SAVE_CALCULATION_RESPONSE = {
	fileId: "3fa85f64-5717-4562-b3fc-2c963f66afa6"
};

export const GET_EMISSION_OVERVIEW_FOR_BAR_CHART_RESPONSE = {
	barSeries: [
		{
			name: "Upstream Scope3 Emission",
			bars: [
				{
					name: "devicelist00.xlsx",
					value: 30,
					unit: "kgCO2e"
				},
				{
					name: "01234_template.xlsx",
					value: 22,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Scope2 Emission",
			bars: [
				{
					name: "devicelist00.xlsx",
					value: 25,
					unit: "kgCO2e"
				},
				{
					name: "01234_template.xlsx",
					value: 20,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Downstream Scope3 Emission",
			bars: [
				{
					name: "devicelist00.xlsx",
					value: 27,
					unit: "kgCO2e"
				},
				{
					name: "01234_template.xlsx",
					value: 19,
					unit: "kgCO2e"
				}
			]
		}
	]
};

export const GET_TOTAL_EMISSION_BY_CATEGORY_RESPONSE = {
	barSeries: [
		{
			name: "file1.xlsx",
			bars: [
				{
					name: "Server",
					value: 11,
					unit: "kgCO2e"
				},
				{
					name: "Network",
					value: 10,
					unit: "kgCO2e"
				},
				{
					name: "Storage",
					value: 2,
					unit: "kgCO2e"
				},
				{
					name: "Firewall",
					value: 3,
					unit: "kgCO2e"
				},
				{
					name: "Network Equipment Chassis",
					value: 20,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal",
					value: 50,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 2",
					value: 43,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 3",
					value: 60,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 4",
					value: 38,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "file2.xlsx",
			bars: [
				{
					name: "Server",
					value: 20,
					unit: "kgCO2e"
				},
				{
					name: "Network",
					value: 21,
					unit: "kgCO2e"
				},
				{
					name: "Storage",
					value: 10,
					unit: "kgCO2e"
				},
				{
					name: "Firewall",
					value: 18,
					unit: "kgCO2e"
				},
				{
					name: "Network Equipment Chassis",
					value: 19,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal",
					value: 33,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 2",
					value: 50,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 3",
					value: 29,
					unit: "kgCO2e"
				},
				{
					name: "Payment Terminal 4",
					value: 16,
					unit: "kgCO2e"
				}
			]
		}
	]
};

export const GET_TOTAL_EMISSION_BY_MANUFACTURER_PERCENTAGE_RESPONSE = {
	barSeries: [
		{
			name: "IBM",
			bars: [
				{
					name: "file1.xlsx",
					value: 10,
					unit: "%"
				},
				{
					name: "file2.xlsx",
					value: 30,
					unit: "%"
				},
				{
					name: "file3.xlsx",
					value: 5,
					unit: "%"
				}
			]
		},
		{
			name: "Microsoft",
			bars: [
				{
					name: "file1.xlsx",
					value: 20,
					unit: "%"
				},
				{
					name: "file2.xlsx",
					value: 46,
					unit: "%"
				},
				{
					name: "file3.xlsx",
					value: 10,
					unit: "%"
				}
			]
		},
		{
			name: "Dell",
			bars: [
				{
					name: "file1.xlsx",
					value: 10,
					unit: "%"
				},
				{
					name: "file2.xlsx",
					value: 22,
					unit: "%"
				},
				{
					name: "file3.xlsx",
					value: 50,
					unit: "%"
				}
			]
		}
	]
};

export const GET_TOTAL_EMISSION_BY_MANUFACTURER_VALUE_RESPONSE = {
	barSeries: [
		{
			name: "IBM",
			bars: [
				{
					name: "file1.xlsx",
					value: 100,
					unit: "kgCO2e"
				},
				{
					name: "file2.xlsx",
					value: 300,
					unit: "kgCO2e"
				},
				{
					name: "file3.xlsx",
					value: 50,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Microsoft",
			bars: [
				{
					name: "file1.xlsx",
					value: 200,
					unit: "kgCO2e"
				},
				{
					name: "file2.xlsx",
					value: 460,
					unit: "kgCO2e"
				},
				{
					name: "file3.xlsx",
					value: 100,
					unit: "kgCO2e"
				}
			]
		},
		{
			name: "Dell",
			bars: [
				{
					name: "file1.xlsx",
					value: 100,
					unit: "kgCO2e"
				},
				{
					name: "file2.xlsx",
					value: 220,
					unit: "kgCO2e"
				},
				{
					name: "file3.xlsx",
					value: 500,
					unit: "kgCO2e"
				}
			]
		}
	]
};
